// extracted by mini-css-extract-plugin
export default {"joinBtn":"TimeEventsAgenda_joinBtn__CKCSf"};